import { WbGrid, WbGridCol, WbGridRow } from '@workbench/react';
import FallbackImage from '../../../Assets/Vimdt/Images/fallback_vehicle.jpeg';
import './ModelsImageList.scss';

const COL_SPAN = { 1: 12, 2: 6, 3: 4, 4: 3, 6: 2 };

function ModelCard({ url, title, imageType }) {
	const download = () => {
		const link = document.createElement('a');
		link.href = url;
		link.download = `${title}.${imageType}`;
		link.click();
	};

	const handleDownloadKeyDown = (event) => {
		if (event.key !== 'Enter' && event.key !== ' ') return;
		event.preventDefault();
		download();
	};

	return (
		<div
			className="vimdt-model-card"
			role="button"
			tabIndex={0}
			onClick={download}
			onKeyDown={handleDownloadKeyDown}
		>
			<img className="vimdt-model-card__image" src={url || FallbackImage} alt={title} />
			<div className="vimdt-model-card__title">{title}</div>
		</div>
	);
}

function ModelsImageList({ imageList, imageType, rowCount = 6 }) {
	const span = COL_SPAN[rowCount] || 2;

	return (
		<WbGrid fullWidth>
			<WbGridRow>
				{imageList.map(({ url, title }) => (
					<WbGridCol key={url} mq1={12} mq3={6} mq5={span}>
						<ModelCard url={url} title={title} imageType={imageType} />
					</WbGridCol>
				))}
			</WbGridRow>
		</WbGrid>
	);
}

export default ModelsImageList;
